import { useMemo } from "react";

import type { CheckoutConfiguration } from "@jti/commerce";
import { getUser } from "@jti/rest-api";
import { useSelector } from "@jti/store/reduxHooks";

import { hasMatchingSku } from "@checkout/utils";

export const useShouldShowLoyaltyReminderDialog = (loyalty: CheckoutConfiguration["loyalty"]): boolean => {
  const user = getUser();
  const items = useSelector((state) => state.cart.items);

  return useMemo(() => {
    if (
      !loyalty.reminderDialogSKUs ||
      !loyalty.showReminderDialog ||
      !user?.referrals?.can_receive_discount ||
      !user?.email
    )
      return false;
    return !hasMatchingSku(items, loyalty.reminderDialogSKUs.split(","));
  }, [
    items,
    loyalty.reminderDialogSKUs,
    loyalty.showReminderDialog,
    user?.email,
    user?.referrals?.can_receive_discount,
  ]);
};
